/**
 *
 * Component: Text
 * Date: 26/10/2020
 *
 */

import React from 'react';
import styles from './style.module.css';

function Text({ type, text, className, ...rest }: any) {
  const customStyles: string[] = [];
  if (className)
    className.split(' ').forEach((classname: any) => {
      customStyles.push(styles[classname]);
    });
  return (
    <span
      className={`${styles[type] ? styles[type] : ''} ${customStyles
        .join(' ')
        .toString()}`}
      {...rest}
    >
      {text}
    </span>
  );
}

export default Text;
